import { useUserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
const useLogout = () => {
 const context = useUserContext();
 const nav = useNavigate();
 const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  context?.setuser(null);
  nav("/login");
 };
 return logout;
};

export default useLogout;
